import { SVGProps } from 'react';

export default function Prepare2(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="timeline-layout--svg--icon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_2317_3398)">
        <path
          d="M13.3333 6.66667H11.6667V2.5H13.3333V6.66667ZM19.1667 5.83333V10C19.1667 11.8383 17.6717 13.3333 15.8333 13.3333H9.16667C7.32833 13.3333 5.83333 11.8383 5.83333 10V5.83333C5.83333 3.995 7.32833 2.5 9.16667 2.5H10V6.66667C10 7.58583 10.7475 8.33333 11.6667 8.33333H13.3333C14.2525 8.33333 15 7.58583 15 6.66667V2.5H15.8333C17.6717 2.5 19.1667 3.995 19.1667 5.83333ZM19.1667 15H6.66667C5.28833 15 4.16667 13.8783 4.16667 12.5V3.33333C4.16667 1.495 2.67167 0 0.833333 0C0.61232 0 0.400358 0.0877974 0.244078 0.244078C0.0877974 0.400358 0 0.61232 0 0.833333C0 1.05435 0.0877974 1.26631 0.244078 1.42259C0.400358 1.57887 0.61232 1.66667 0.833333 1.66667C1.7525 1.66667 2.5 2.41417 2.5 3.33333V12.5C2.50138 13.3097 2.73853 14.1015 3.18249 14.7787C3.62645 15.4559 4.25799 15.9891 5 16.3133V17.5C5 18.8783 6.12167 20 7.5 20C8.87833 20 10 18.8783 10 17.5V16.6667H14.1667V17.5C14.1667 18.8783 15.2883 20 16.6667 20C18.045 20 19.1667 18.8783 19.1667 17.5V16.6667C19.3877 16.6667 19.5996 16.5789 19.7559 16.4226C19.9122 16.2663 20 16.0543 20 15.8333C20 15.6123 19.9122 15.4004 19.7559 15.2441C19.5996 15.0878 19.3877 15 19.1667 15Z"
          fill={props.fill || 'black'}
        />
      </g>
      <defs>
        <clipPath id="clip0_2317_3398">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
